import type { BackendEntities } from 'app/lib/betting/betting-entities';
import type { SubscribeAction } from 'app/lib/signalr';

// ---

export const SUBSCRIBE = 'LIVE_HUB:SUBSCRIBE';
export const UNSUBSCRIBE = 'LIVE_HUB:UNSUBSCRIBE';
export const APPLY_STATE = 'LIVE_HUB:APPLY_STATE';

export type LiveHubSubscribe = SubscribeAction<typeof SUBSCRIBE, {
  signature: string;
  topic: string;
}>;

export type LiveHubUnsubscribe = SubscribeAction<typeof UNSUBSCRIBE>;

export type LiveHubApplyState = {
  type: typeof APPLY_STATE;
  payload: BackendEntities;
};
export type LiveHubActionTypes = LiveHubSubscribe | LiveHubUnsubscribe;

export const LIVE_TOPIC = 'live';

export const subscribe = (): LiveHubActionTypes => ({
  type: SUBSCRIBE,
  payload: {
    topic: LIVE_TOPIC,
    signature: LIVE_TOPIC,
  },
});

export const unsubscribe = (): LiveHubActionTypes => ({
  type: UNSUBSCRIBE,
  payload: {
    topic: LIVE_TOPIC,
  },
});

export const applyLiveState = (payload: BackendEntities) => ({
  type: APPLY_STATE,
  payload,
});
